/**
 * Maximum size of a single uploaded document (PDF or blob), matching the backend limit.
 * Images keep their own, smaller limits; e-mail attachments are capped separately by AWS SES.
 */
export const MAX_DOCUMENT_UPLOAD_SIZE_MB = 25;

const BYTES_PER_MEGABYTE = 1024 * 1024;

export function megabytesToBytes(megabytes: number): number {
  return megabytes * BYTES_PER_MEGABYTE;
}

export const MAX_DOCUMENT_UPLOAD_SIZE_BYTES = megabytesToBytes(MAX_DOCUMENT_UPLOAD_SIZE_MB);
